module.exports = __webpack_public_path__ + "img/user-primary.cfcab728.svg";